import "./Table.css"

interface TableProps {
  children?: React.ReactNode
  className?: string
}

function Table({ children, className }: TableProps) {
  return (
    <div className={`main-table__cont ${className || ""}`}>
      <table className={`main-table w-100 ${className || ""}`}>
        {children}
      </table>
    </div>
  )
}

const Header = ({ children, className }: TableProps) => {
  return (
    <thead>
      <tr className={`table__header ${className || ""}`}>{children}</tr>
    </thead>
  )
}

const HeaderCell = ({ children, className }: TableProps) => {
  return (
    <th className={`table__cell table__cell-header ${className || ""}`}>
      {children}
    </th>
  )
}

const Body = ({ children, className }: TableProps) => {
  return <tbody className={`${className || ""}`}>{children}</tbody>
}

const Row = ({
  children,
  className,
  onClick,
  style,
}: TableProps & {
  onClick?: () => void
  style?: React.CSSProperties
}) => {
  return (
    <tr
      onClick={onClick}
      style={style}
      className={`table__row ${className || ""}`}
    >
      {children}
    </tr>
  )
}

const Cell = ({ children, className }: TableProps) => {
  return <td className={`table__cell ${className || ""}`}>{children}</td>
}

export default Table
export { Body, Cell, Header, HeaderCell, Row }
